import React from 'react';
import { Provider } from 'react-redux';
import 'whatwg-fetch';
import 'antd-mobile/dist/antd-mobile.css'; // 确保导入 antd-mobile 样式
import './App.scss';
import store, {history} from './redux/configureStore';
import HomePage from './pages/HomePage';
import { ConnectedRouter } from 'connected-react-router'
import Translate from './components/Translate';
import CoreLayout from './components/CoreLayout';
import { Route, Switch } from 'react-router-dom';

// import  VConsole  from  'vconsole';
// let vConsole = new VConsole();

function App() {
  return (
    <Provider store={store}>
      <Translate>
        <CoreLayout>
          <ConnectedRouter history={history}>
            <Switch>
              <Route path='/home' component={HomePage} />
              <Route path='*' component={HomePage} />
            </Switch>
          </ConnectedRouter>
        </CoreLayout>
      </Translate>
    </Provider>
  );
}
  
export default App;
